import { MediaQueries } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  background: white;
  width: 100%;
  z-index: 500;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);

  & ~ .askdoctor-popup {
    box-shadow: none;
  }

  ${MediaQueries.mbUp} {
    right: 0;
    width: 436px;
  }

  & ~ [data-open='true'] {
    position: fixed;
    z-index: 600;
  }
`
